import React from "react";
import { Navigate, Link } from "react-router-dom";
import { Landing } from "./Landing.jsx";
import { useAuth } from "../hooks/useAuth.jsx";
import { landingFor } from "../lib/roles.js";

/**
 * Entry fork: the product landing at dev.telltheteam.app (and, as a static
 * "Coming soon" render, at telltheteam.app).
 *
 * Oct 18 rewrite. The Roz demo is gone: a sample profile whose six snippet
 * players didn't play, whose one clip did, and whose photo wasn't anonymised
 * enough, left a visitor unsure whether they were looking at the real thing,
 * a demo, or a broken page. Nothing on this page now looks interactive unless
 * it is. In its place: what her team gets, how it works, and who makes it
 * (the company copy from vizette.net).
 *
 * Copy rules kept from the first version: no "SLS", "client-rep", "DSP" in the
 * family-facing lines, and the word "client" never appears. Lead with warmth.
 *
 * The page itself is Landing.jsx. <Landing comingSoon /> is the telltheteam.app page: same content, no
 * buttons, no links, no sign-in, and a "Coming soon" watermark. It uses no
 * router or auth, so scripts/build-coming-soon.mjs can render it to plain HTML
 * (hosted separately, beside vizette.net, never by this app).
 * Responsive layout is CSS (one breakpoint, 640px, mirroring useIsCompact) so
 * that static render is responsive too.
 */

export default function EntryFork() {
  const { user, loading } = useAuth();
  // Already signed in: never ask someone to re-declare who they are.
  if (!loading && user) {
    return <Navigate to={landingFor(user)} replace />;
  }
  return <Landing Link={Link} />;
}

